import { Order } from '../../domain/orders/order.model'
import { GetOrdersPreBillResponse } from '../../domain/orders/get-orders.-prebill.response'
import { OrdersDataFilters } from '../../domain/orders/data-filters.model'

export function fromGetPreBillOrdersResponse(
  response: GetOrdersPreBillResponse,
  filters?: OrdersDataFilters
): Order[] {
  if (!Array.isArray(response.value)) return []
  return response.value.map<Order>(
    order =>
      <Order>{
        belongsToPage: filters?.page,
        id: order.Id,
        legacyId: order.OrderId,
        customerCharge: order.CustomerCharge,
        customerId: order.CustomerId,
        customer: {
          name: order.CustomerName
        },
        typeOfException: order.TypeOfException,
        orderOwnerEmail: order.UserOwner?.Email ?? null,
        vendorName: order.VendorName,
        customerName: order.CustomerName,
        deliveryDate: toDate(order.DeliveryDate),
        orderNumber: order.OrderNumber,
        shipDate: toDate(order.ShipDate),
        vendorCharge: order.VendorCharge,
        shipmentNumber: order.ShipmentNumber,
        createDate: toDate(order.CreateDate)
      }
  )
}

function toDate(date: string | null) {
  return date ? new Date(date) : undefined
}
